import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acadmy-payment',
  templateUrl: './acadmy-payment.component.html',
  styleUrls: ['./acadmy-payment.component.css']
})
export class AcadmyPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
